export default __webpack_public_path__ + "static/media/opensea.c6e82c37.webp";